export enum Language {
    BG = 'bg',
    EN = 'en'
}
